import SourceCategoryFilterOverlay from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.component';
import ResetButton from 'Component/ResetButton';

export default class CategoryFilterOverlay extends SourceCategoryFilterOverlay {
    renderHeading() {
        return (
            <h2 block="CategoryFilterOverlay" elem="Heading">
                { __('Filters') }
            </h2>
        );
    }

    renderResetButton() {
        const { onSeeResultsClick } = this.props;

        return (
            <ResetButton
              onClick={ onSeeResultsClick }
              mix={ { block: 'CategoryFilterOverlay', elem: 'ResetButton' } }
            >
                { __('Reset filters') }
            </ResetButton>
        );
    }

    renderNoResults() {
        return (
            <p block="CategoryFilterOverlay" elem="NoResults">
                { __("The selected filter combination has returned 0 results. Try another filter") }
            </p>
        );
    }
}
